import create from './create'
import update from './update'
import remove from './remove'
import list from './list'
import details from './details'

export enum InteractivityType {
  SEATABLE = 'seatable',
  ALLOCATABLE = 'allocatable',
}

export default { create, update, remove, list, details }
